import React, {useState} from 'react';

import {withCookies} from '@optimaxdev/utils';
import {useLocation} from 'react-router-dom';

import {useHostSelector} from 'hooks/hostHooks/hostHooks';
import {getRouterInfo} from 'selectors/router';

import {BannerContentType, BannerPropsType} from '../../types';
import {getBannerContent, getBannerImage} from '../../utils/utils';
import {ImageBanner} from '../imageBanner/imageBanner';
import {Popup} from '../popup/popup';
import {TrustpilotWrapper} from '../trustpilotWrapper/trustpilotWrapper';

export type PropsType = {
    json: string;
    component: React.FC<BannerPropsType>;
    cookies?: Record<string, string>;
    fallbackBannerData?: Partial<BannerContentType>;
};

/**
 * A banner based on a template
 */
export const BannerWrapper: React.FC<PropsType> = ({
    // eslint-disable-next-line @typescript-eslint/naming-convention
    component: Component,
    cookies,
    fallbackBannerData = {},
    json,
}) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const {search} = useLocation();
    const {type: pageType = ''} = useHostSelector(getRouterInfo);

    const data = getBannerContent(json, search, cookies);
    const shouldShowTrustpilotBlock = pageType === 'category';

    if (!data?.coupons) return null;

    const openModal = () => {
        setIsModalOpen(true);
    };

    const image = getBannerImage(data);

    return (
        <>
            <Component data={data} openModal={openModal} />
            {image && <ImageBanner data={data} fallbackBannerData={fallbackBannerData} />}
            {shouldShowTrustpilotBlock && String(data.trust_strip) === 'true' && (
                <TrustpilotWrapper />
            )}
            <Popup closeModal={() => setIsModalOpen(false)} data={data} isOpen={isModalOpen} />
        </>
    );
};

export const BannerWrapperConnected = withCookies(BannerWrapper);
